import { useQuery } from "@tanstack/react-query";

import { orpc } from "@/client";

export function ClinicaNavBadge() {
	const { data } = useQuery(orpc.clinica.pendencias.queryOptions());

	if (data === undefined || data.length === 0) {
		return null;
	}

	return (
		<span className="ml-auto rounded-full bg-warning px-1.5 py-0.5 text-xs font-medium text-warning-foreground">
			{data.length}
		</span>
	);
}
